// removed by extract-text-webpack-plugin
module.exports = {"support":"support___1y5Ow","container":"container___3iGW3","column":"column___2hT4O","wrapper":"wrapper___m9Vj7","column-title":"column-title___3OeaQ","container-using":"container-using___8aErp","social-icons":"social-icons___2T5en","email":"email___3IyG4","twitter":"twitter___TWBLH","facebook":"facebook___1u-0v","pinterest":"pinterest___3OMTQ","container-copyright":"container-copyright___2W9Wd","copyright":"copyright___Xct_z","health":"health___3LF-z","sitemap":"sitemap___1cAJ6","bold-title":"bold-title___k8bLv","new-site":"new-site___1y71T","classic-link":"classic-link___2DbCN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/Support/Support.scss
// module id = /MQq
// module chunks = 57